//
//
//
//

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    breadcrumbItems() {
      return this.items
    },
  },
}
